import React from 'react'
import {Project} from '../../components'

export default function MyProjects () {
    return (
        <>
            <Project />          
            
        </>
    )
}
